var _path, _g, _path2, _path3, _path4, _g2, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 346,
    viewBox: "0 0 365 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9832 7.32608C14.9832 6.14929 15.9371 5.19531 17.1139 5.19531L247.843 5.19531C248.505 5.19531 249.13 5.50347 249.533 6.0291L364.369 155.712C364.654 156.085 364.809 156.54 364.809 157.009V345.999H117.793L15.5815 240.199C15.1977 239.802 14.9832 239.271 14.9832 238.718V7.32608Z",
    fill: "url(#paint0_linear_6495_186381)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6495_186381)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.7871,
    y: 2,
    width: 234.384,
    height: 234.384,
    rx: 4.26153,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.487092,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7678 20.1114C27.7678 18.9346 28.7218 17.9806 29.8986 17.9806H229.125C230.302 17.9806 231.256 18.9346 231.256 20.1114V220.403C231.256 221.58 230.302 222.534 229.125 222.534H29.8986C28.7218 222.534 27.7678 221.58 27.7678 220.403V20.1114Z",
    fill: "url(#paint1_linear_6495_186381)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6495_186381)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7024 16.916H232.321V171.467L228.089 163.969L224.189 177.53L218.013 170.888L212.676 173.598L196.855 170.888L193.928 222.535L187.154 222.649L182.217 220.89L172.392 222.535L165.612 219.763L155.369 222.535L150.042 158.602L144.365 222.535L135.753 220.832L127.762 223.359L117.282 220.404L101.213 222.535L96.4754 219.265L91.4202 222.535H80.2615V80.839C80.2615 80.839 75.9913 142.611 67.9449 158.602C64.5061 165.437 58.9661 167.292 55.341 168.878C50.4838 171.005 46.8132 171.467 34.7111 171.467C13.577 171.467 6.28186 149.054 6.28186 149.054C6.28186 149.054 14.4267 143.375 19.5234 131.823C24.62 120.271 26.7024 80.839 26.7024 80.839V16.916Z",
    fill: "url(#paint2_linear_6495_186381)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6495_186381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 227,
    height: 208
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7024 16.916H232.321V171.467L228.089 163.969L224.189 177.53L218.013 170.888L212.676 173.598L196.855 170.888L193.928 222.535L187.154 222.649L182.217 220.89L172.392 222.535L165.612 219.763L155.369 222.535L150.042 158.602L144.365 222.535L135.753 220.832L127.762 223.359L117.282 220.404L101.213 222.535L96.4754 219.265L91.4202 222.535H80.2615V80.839C80.2615 80.839 75.9913 142.611 67.9449 158.602C64.5061 165.437 58.9661 167.292 55.341 168.878C50.4838 171.005 46.8132 171.467 34.7111 171.467C13.577 171.467 6.28186 149.054 6.28186 149.054C6.28186 149.054 14.4267 143.375 19.5234 131.823C24.62 120.271 26.7024 80.839 26.7024 80.839V16.916Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6495_186381)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.0526 145.008H74.9374V132.187H84.1295V120.528H74.9374V75.1966H54.3279L26.3163 119.996V132.187H61.0526V145.008ZM39.04 120.915V120.528L61.0042 85.7433H61.3429V120.915H39.04ZM136.296 146.217C154.003 146.217 164.743 132.332 164.743 110.126V110.03C164.743 87.8236 154.003 73.9871 136.296 73.9871C118.589 73.9871 107.849 87.8236 107.849 110.03V110.126C107.849 132.332 118.589 146.217 136.296 146.217ZM136.296 134.51C127.588 134.51 122.604 125.463 122.604 110.126V110.03C122.604 94.6934 127.588 85.6949 136.296 85.6949C145.004 85.6949 149.987 94.6934 149.987 110.03V110.126C149.987 125.463 145.004 134.51 136.296 134.51ZM224.118 145.008H238.002V132.187H247.194V120.528H238.002V75.1966H217.393L189.381 119.996V132.187H224.118V145.008ZM202.105 120.915V120.528L224.069 85.7433H224.408V120.915H202.105Z",
    fill: "url(#paint3_linear_6495_186381)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 140.027H54.6829C54.6829 140.027 58.8194 160.762 68.1353 158.365C64.0922 166.59 55.6621 172.99 37.7327 172.99C19.8033 172.99 12.3788 166.145 7.94124 161.358C3.50373 156.571 0 140.027 0 140.027Z",
    fill: "url(#paint4_linear_6495_186381)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6495_186381",
    x: 6.4602,
    y: 0.934618,
    width: 266.346,
    height: 266.346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.6538,
    dy: 14.9154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.99037
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.0403646 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6495_186381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6495_186381",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6495_186381",
    x1: 389.032,
    y1: 133.585,
    x2: 141.108,
    y2: -125.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4B0D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6495_186381",
    x1: 110.917,
    y1: 183.089,
    x2: 89.9043,
    y2: 123.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C8DE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B798E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6495_186381",
    x1: 17.5246,
    y1: 2.7816,
    x2: -8.39069,
    y2: 189.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6495_186381",
    x1: 30.6402,
    y1: 52.8061,
    x2: 25.3632,
    y2: 155.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6495_186381",
    x1: -16.3052,
    y1: 141.207,
    x2: -15.161,
    y2: 185.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6495_186381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.927,
    height: 206.684,
    fill: "white",
    transform: "translate(5.39478 16.916)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.96ac4e33609981e2e66f85f81a823248.svg";
export { ForwardRef as ReactComponent };